// extracted by mini-css-extract-plugin
export default {"labels":"Wql2K","label":"l_g7a"};